export enum ChartTypes {
  Quantity = 'quantity',
  Frequency = 'frequency',
  Ratio = 'ratio',
}
